var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconRealizeVistoria(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 23.25,
    stroke: "#FFBC01",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.92 18.01C30.72 17.42 30.16 17 29.5 17H18.5C17.84 17 17.29 17.42 17.08 18.01L15 24V32C15 32.55 15.45 33 16 33H17C17.55 33 18 32.55 18 32V31H30V32C30 32.55 30.45 33 31 33H32C32.55 33 33 32.55 33 32V24L30.92 18.01ZM19.5 28C18.67 28 18 27.33 18 26.5C18 25.67 18.67 25 19.5 25C20.33 25 21 25.67 21 26.5C21 27.33 20.33 28 19.5 28ZM28.5 28C27.67 28 27 27.33 27 26.5C27 25.67 27.67 25 28.5 25C29.33 25 30 25.67 30 26.5C30 27.33 29.33 28 28.5 28ZM17.81 22L18.85 19H29.14L30.18 22H17.81Z",
    fill: "#FFBC01"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRealizeVistoria);
export default __webpack_public_path__ + "static/media/icon-realize-vistoria.c140528cdc8614c3f3f5f770a65b85e5.svg";
export { ForwardRef as ReactComponent };